export const environment = {
  production: true,
  envVar: {
    // clientSecret: '',
      API_BASE_URL: "https://apicf.estm.com.au",
      API_BASE_WS_URL: "wss://quonjr0kl2.execute-api.ap-southeast-2.amazonaws.com/prod",
      DEPLOYED_ENV_NAME: "production",
      clientId: "26hqnu13nvgal36uib0fa2efug",
      redirectURL: "https://cgtview.estm.com.au/callback",
      cognitoDomain: "https://sso.estm.com.au",
      oidcLogout: "https://dev-udnox1jv7q2zja0f.au.auth0.com/oidc/logout"
}
};
